/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
/**
 * 
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Subscription
     */
    userId?: number;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    contentfulProgramId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    stripePaymentReference?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    subscriptionStarted?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    modified?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    stripeId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    subscriptionPeriodEnd?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Subscription
     */
    subscriptionPeriodStart?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    subscriptionStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    lastInvoiceStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Subscription
     */
    lastInvoiceUrl?: string | null;
    /**
     * 
     * @type {User}
     * @memberof Subscription
     */
    user?: User;
}

/**
 * Check if a given object implements the Subscription interface.
 */
export function instanceOfSubscription(value: object): value is Subscription {
    return true;
}

export function SubscriptionFromJSON(json: any): Subscription {
    return SubscriptionFromJSONTyped(json, false);
}

export function SubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subscription {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'contentfulProgramId': json['contentfulProgramId'] == null ? undefined : json['contentfulProgramId'],
        'stripePaymentReference': json['stripePaymentReference'] == null ? undefined : json['stripePaymentReference'],
        'subscriptionStarted': json['subscriptionStarted'] == null ? undefined : (new Date(json['subscriptionStarted'])),
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'modified': json['modified'] == null ? undefined : (new Date(json['modified'])),
        'stripeId': json['stripeId'] == null ? undefined : json['stripeId'],
        'subscriptionPeriodEnd': json['subscriptionPeriodEnd'] == null ? undefined : (new Date(json['subscriptionPeriodEnd'])),
        'subscriptionPeriodStart': json['subscriptionPeriodStart'] == null ? undefined : (new Date(json['subscriptionPeriodStart'])),
        'subscriptionStatus': json['subscriptionStatus'] == null ? undefined : json['subscriptionStatus'],
        'lastInvoiceStatus': json['lastInvoiceStatus'] == null ? undefined : json['lastInvoiceStatus'],
        'lastInvoiceUrl': json['lastInvoiceUrl'] == null ? undefined : json['lastInvoiceUrl'],
        'user': json['user'] == null ? undefined : (require('./User') as typeof import('./User')).UserFromJSON(json['user']),
    };
}

export function SubscriptionToJSON(json: any): Subscription {
    return SubscriptionToJSONTyped(json, false);
}

export function SubscriptionToJSONTyped(value?: Subscription | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'contentfulProgramId': value['contentfulProgramId'],
        'stripePaymentReference': value['stripePaymentReference'],
        'subscriptionStarted': value['subscriptionStarted'] == null ? value['subscriptionStarted'] : value['subscriptionStarted'].toISOString(),
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'modified': value['modified'] == null ? value['modified'] : value['modified'].toISOString(),
        'stripeId': value['stripeId'],
        'subscriptionPeriodEnd': value['subscriptionPeriodEnd'] == null ? value['subscriptionPeriodEnd'] : value['subscriptionPeriodEnd'].toISOString(),
        'subscriptionPeriodStart': value['subscriptionPeriodStart'] == null ? value['subscriptionPeriodStart'] : value['subscriptionPeriodStart'].toISOString(),
        'subscriptionStatus': value['subscriptionStatus'],
        'lastInvoiceStatus': value['lastInvoiceStatus'],
        'lastInvoiceUrl': value['lastInvoiceUrl'],
        'user': (require('./User') as typeof import('./User')).UserToJSON(value['user']),
    };
}

